import { Box, Button, FormLabel, Image, Input, ListItem, Stack, Switch, Text, Textarea, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { IMG } from '../../../Content/Content';
import { FaAngleRight } from "react-icons/fa";
import { AiOutlineReload, AiFillCloseCircle } from "react-icons/ai";
const Sidebar = () => {
    const navigate = useNavigate()
    const [advMode, setAdvMode] = useState(false)

    return (
        <VStack bg="#FFFFFF" boxShadow={advMode ? "0px 4px 4px 4px rgba(0, 0, 0, 0.25)" : ""} paddingRight="20px" paddingBottom="35px" h="100%">
            {/* left Side */}
            <Box>
                {/* LOGO */}
                <Stack>
                    <NavLink to='/'>
                        <Image src={IMG.logo} w="209px" h="156px" position="relative" left="-50px"/>
                    </NavLink>
                </Stack>
            </Box>

            <Box w="100%" display="flex" alignItems="start">
                <Box w="70px">
                    <Stack
                        top="0"
                        left="0"
                        bg="rgba(255, 255, 255, 0.91)"
                        w="57px"
                        h="477px"
                        boxShadow=" 0px 2px 4px 1px rgba(0, 0, 0, 0.25)"
                        borderRadius="2px"
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Box>
                            <Box paddingY="5px">
                                <NavLink to="/product-photos" className="d-flex align-items-center justify-content-center flex-column p-2">
                                    <Image src={IMG.productPhotos} w="35px" />
                                    <Text fontSize="10px" paddingY={"2px"}>Product Photos</Text>
                                </NavLink>
                            </Box>
                            <Box paddingY="5px">
                                <NavLink to="/copy-writing" className="d-flex align-items-center justify-content-center flex-column p-2">
                                    <Image src={IMG.copyWriting} w="28px" />
                                    <Text fontSize="10px" textAlign="center" paddingY={"2px"}>Copy Writing</Text>
                                </NavLink>
                            </Box>
                            <Box paddingY="5px">
                                <NavLink to="/social-media" className="d-flex align-items-center justify-content-center flex-column p-2">
                                    <Image src={IMG.SocialMedia} w="28px" />
                                    <Text fontSize="10px" textAlign="center" paddingY={"2px"}>Social Media</Text>
                                </NavLink>
                            </Box>

                            <Box paddingY="5px">
                                <NavLink to="/social-media" className="d-flex align-items-center justify-content-center flex-column p-2">
                                    <Image src={IMG.GenerateLeads} w="28px" />
                                    <Text fontSize="10px" textAlign="center" paddingY={"2px"}>Generate Leads</Text>
                                </NavLink>
                            </Box>
                        </Box>

                    </Stack>
                </Box>

                {/* Right- side */}

                <Box w="280px">
                    {/* Top Bar */}
                    <Stack flexDirection={'row'} alignItems="center" justifyContent="space-between">
                        <Box>
                            <Switch display="flex" fontSize="12px" fontWeight="600" alignItems="center" onChange={() => setAdvMode(!advMode)}>
                                Advance Mode</Switch>
                        </Box>


                        <Box display={advMode ? "flex" : "none"} alignItems="center">
                            <Button type="button" bg="#F8BC4E" marginEnd="10px" _hover={{ bg: "#F8BC4E" }} color="#fff" padding="4px 10px" h="auto" w="auto"> <AiOutlineReload className='me-2' /> Reset</Button>
                            <Button type="button" bg="#F8BC4E" _hover={{ bg: "#F8BC4E" }} color="#fff" padding="4px 10px" h="auto" w="auto"> <AiFillCloseCircle /></Button>
                        </Box>

                    </Stack>

                    {/* Generate */}
                    <Stack paddingY="20px">
                        <Button type="button"
                            color="#fff"
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            padding="15px 20px"
                            borderRadius="3px"
                            h="auto"
                            _hover={{ background: "linear-gradient(255.15deg, #F8BC4E -4.51%, #F14990 41.94%, rgba(72, 20, 44, 0.81) 100.01%)" }}
                            bg="linear-gradient(255.15deg, #F8BC4E -4.51%, #F14990 41.94%, rgba(72, 20, 44, 0.81) 100.01%)">
                            <Text fontSize="16px" fontWeight="400">Generate</Text>
                            <Text fontSize="10px" fontWeight="400" color="rgba(0, 0, 0, 0.53)">1 credit</Text>
                        </Button>
                    </Stack>

                    {/* Product  */}
                    <Stack paddingY="20px">
                        <Button type="button"
                            color="rgba(0, 0, 0, 0.88)"
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            padding="15px 20px"
                            h="auto"
                            _hover={{ background: "#F5F5F5" }}
                            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                            borderRadius="3px"
                            bg="#F5F5F5"
                            onClick={()=>navigate('/dashboard/product')}
                            >
                            <Text fontSize="16px" fontWeight="400">Product</Text>
                            <Text fontSize="18px"><FaAngleRight /></Text>
                        </Button>
                    </Stack>

                    {/* Text Prompt */}
                    <Stack paddingY="20px">
                        <Text fontSize="16px" fontWeight="500">Text Prompt</Text>
                        <Textarea placeholder="(optional)"
                            padding="10px"
                            _placeholder={{ color: "rgba(0, 0, 0, 0.24)" }}
                            bg="#F5F5F5"
                            fontSize="14px"
                            boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                            color="rgba(0, 0, 0, 0.24)">
                        </Textarea>
                    </Stack>

                    {/* Advance Mode */}
                    <Box display={advMode ? "block" : 'none'}>
                        <Stack paddingY="20px">
                            <Text fontSize="16px" fontWeight="500">Negative Prompt</Text>
                            <Textarea placeholder="(optional)"
                                padding="10px"
                                _placeholder={{ color: "rgba(0, 0, 0, 0.24)" }}
                                bg="#F5F5F5"
                                fontSize="14px"
                                boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                                color="rgba(0, 0, 0, 0.24)">
                            </Textarea>
                        </Stack>

                        {/* style */}
                        <Stack paddingY="20px">
                            <Button type="button"
                                onClick={()=> navigate('/dashboard/styles')}
                                color="rgba(0, 0, 0, 0.88)"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                padding="15px 20px"
                                h="auto"
                                _hover={{ background: "transparent" }}
                                borderRadius="3px"
                                bg="transparent">
                                <Text fontSize="16px" fontWeight="500">Style</Text>
                                <Text fontSize="18px"><FaAngleRight /></Text>
                            </Button>
                            <Box position="relative" display="flex" alignItems="center" justifyContent="center">
                                <Image src={IMG.styleImage} w="100%" />
                                <Box position="absolute"
                                    bottom="0"
                                    h="100%"
                                    w="100%"
                                    display="flex"
                                    alignItems="end"
                                    justifyContent="center"
                                    left="0" bg="linear-gradient(0deg, rgba(0, 0, 0, 0.6) 26.2%, rgba(255, 255, 255, 0) 100%)">
                                    <Text color="#fff" paddingBottom="20px">Lorem ipsum dolor sit </Text>

                                </Box>

                            </Box>
                        </Stack>

                        {/* Image Guidance */}

                        <Stack paddingY="20px">
                            <Button type="button"
                            onClick={()=>navigate("/dashboard/upload")}
                                color="rgba(0, 0, 0, 0.88)"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                padding="15px 20px"
                                h="auto"
                                _hover={{ background: "transparent" }}
                                borderRadius="3px"
                                bg="transparent">
                                <Text fontSize="16px" fontWeight="500">Image Guidance</Text>
                                <Text fontSize="18px"><FaAngleRight /></Text>
                            </Button>
                            <Box position="relative" display="flex" alignItems="center" justifyContent="center">
                                <Box h="200px" w="100%" bg="#F5F5F5" boxShadow=" 0px 4px 4px rgba(0, 0, 0, 0.25)"
                                    display="flex" alignItems="center" justifyContent="center">
                                    <FormLabel display="flex">
                                        <Input type="file" display="none" />
                                        <Text paddingRight="10px">Upload image</Text> <Image src={IMG.UploadImage} />
                                    </FormLabel>
                                </Box>

                            </Box>
                        </Stack>


                        {/* Images */}
                        <Stack paddingY="5px">
                            <Button type="button"
                                color="rgba(0, 0, 0, 0.88)"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                padding="15px 20px"
                                h="auto"
                                _hover={{ background: "transparent" }}
                                borderRadius="3px"
                                bg="transparent">
                                <Box display="flex" alignItems="center">
                                    <Image src={IMG.UploadImage} display="block" marginRight="10px" />
                                    <Text fontSize="16px" fontWeight="500" marginLeft="10px">Images</Text>
                                </Box>
                                <Text fontSize="18px"><FaAngleRight /></Text>
                            </Button>
                        </Stack>

                        {/* Resolution */}
                        <Stack paddingY="5px">
                            <Button type="button"
                                color="rgba(0, 0, 0, 0.88)"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                padding="15px 20px"
                                h="auto"
                                _hover={{ background: "transparent" }}
                                borderRadius="3px"
                                bg="transparent">
                                <Box display="flex" alignItems="center">
                                    <Image src={IMG.Resolution} display="block" marginRight="10px" />
                                    <Text fontSize="16px" fontWeight="500" marginLeft="10px">Images</Text>
                                </Box>
                                <Text fontSize="18px"><FaAngleRight /></Text>
                            </Button>
                        </Stack>

                        {/* Aspect ratio */}
                        <Stack paddingY="5px">
                            <Button type="button"
                                color="rgba(0, 0, 0, 0.88)"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                padding="15px 20px"
                                h="auto"
                                _hover={{ background: "transparent" }}
                                borderRadius="3px"
                                bg="transparent">
                                <Box display="flex" alignItems="center">
                                    <Image src={IMG.AspectRatio} display="block" marginRight="10px" />
                                    <Text fontSize="16px" fontWeight="500" marginLeft="10px">Images</Text>
                                </Box>
                                <Text fontSize="18px"><FaAngleRight /></Text>
                            </Button>
                        </Stack>
                        <Stack paddingX="20px">
                            <Input
                                placeholder='Random seed'
                                fontSize="14px"
                                color="color: rgba(0, 0, 0, 0.24)"
                                fontWeight="400"
                                type="text" bg="#F5F5F5" boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)" />
                        </Stack>
                    </Box>
                </Box>
            </Box>


        </VStack>
    );
};

export default Sidebar;